module.exports = __webpack_public_path__ + "assets/fonts/Gotham-XLight.f73c425d.otf";